module.exports = new __parcel__URL__("logo.0eae7cf3.svg").toString();